module.exports = __webpack_public_path__ + "static/media/map.9cc6defc.png";